<template>
  <div class="form-group" >
    <checkbox-item-config :product="product" :product-feature="featureProduct"/>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import CheckboxItemConfig from "./CheckboxInput/CheckboxItemConfig.vue";

export default defineComponent({
  name: "FeatureInputCheckbox",
  components: {CheckboxItemConfig},
  props: {
    featureProduct: {},
    product: {},
  },
})
</script>

<style scoped>

</style>